<template>
  <v-row>
    <v-col cols="12" md="6">
      <v-text-field
        v-model="form.email"
        name="email"
        :label="`${$t('PROFILE.EMAIL')} *`"
        :rules="getRulesByName('email')"
        :readonly="readonly"
        :error-messages="errors.email"
        @input="updateValue('email', $event)"
      ></v-text-field>
    </v-col>
    <v-col cols="12" md="6">
      <text-field-password-generate
        v-model="form.password"
        name="password"
        :label="$t('USERS.PASSWORD')"
        :counter="8"
        :readonly="readonly"
        :rules="getRulesByName('password')"
        :error-messages="errors.password"
        @input="updateValue('password', $event)"
      ></text-field-password-generate>
    </v-col>
  </v-row>
</template>

<script>
import TextFieldPasswordGenerate from '@/modules/_global/_components/TextFieldPasswordGenerate';
import formEditable from '@/modules/_global/mixins/form-editable';
import { maxLength, requiredEmail } from '@/modules/_global/variables/rules.js';

export default {
  name: 'UserInformationForm',

  components: {
    TextFieldPasswordGenerate
  },

  mixins: [formEditable],

  data: () => ({
    form: {
      email: '',
      password: ''
    },
    rules: {
      email: requiredEmail,
      password: [maxLength(8)]
    }
  }),

  created() {},

  methods: {}
};
</script>
